<!-- body config after login -->
<div *ngIf="expansionStyle == 'body'">
    <div class="row">
        <div class="col-sm-12">
            <div class="c-form-group">
                <div class="c-form-group__hint">&nbsp;</div>
                <div class="c-form-group__label"><label class="required-label">When Registration Status is</label></div>
                <ccl-multi-select-dropdown
                        [placeholder]="''"
                        [data]="this.allowedRegStatusList"
                        [(ngModel)]="bodyConfig.changeRegStatusConfigs"
                        [settings]="regStatusDropdownSettings"
                        (onSelect)="onItemSelect($event)"
                ></ccl-multi-select-dropdown>
            </div>
        </div>
    </div>
</div>
<div class="row">
    <div class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__hint">&nbsp;</div>
            <div class="c-form-group__label"><label class="required-label">Change to</label></div>
            <ccl-simple-select
                    ariaLabel="Registration Status"
                    [listOfItems]="this.allowedRegStatusList"
                    (valueChange)="bodyConfig.changeRegStatus = $event.value"
                    [value]="bodyConfig.changeRegStatus"
                    [bindLabel]="'name'"
                    [bindValue]="'orderIndex'"
                    [isSearchable]="'true'"
            ></ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>

<!-- SHow pre filter implementation with AFTER login setup CONFIG -->
<!-- SCM-52036 :Session Catalog _ pre-filter changes moved to backlog -->
<!-- <div class="row">
    <div class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="afterLoginPreFilter">Show pre-filters</label>
            <div class="prefilter-login-screen-label">
                <ccl-toggle-button
                    [title]="bodyConfig.showAfterLoginPreFilter ? 'Enable' : 'Disable'"
                    [isChecked]="bodyConfig.showAfterLoginPreFilter"
                    (isCheckedChange)="toggleHTMLEnable($event,'showAfterLoginPreFilter')"
                    >{{ bodyConfig.showAfterLoginPreFilter ? "Enabled" : "Disabled" }}</ccl-toggle-button
                >
            </div>
        </div>
        <div class="c-form-group__hint">&nbsp;</div>
        <ccl-multi-select-dropdown
                *ngIf="bodyConfig.showAfterLoginPreFilter"
                [placeholder]="''"
                [data]="this.sharedService.allowedPreFiltersList"
                [(ngModel)]="bodyConfig.preFilterConfigs"
                [settings]="this.preFilterDropdownSettings"
                (onSelect)="onItemSelect($event)"
        ></ccl-multi-select-dropdown> -->
        <!-- <ccl-simple-select
                *ngIf="bodyConfig.showAfterLoginPreFilter"
                ariaLabel="Available Pre-filters"
                [listOfItems]="this.sharedService.allowedPreFiltersList"
                (valueChange)="bodyConfig.preFilterConfig = $event.value"
                [value]="bodyConfig.preFilterConfig"
                [bindLabel]="'name'"
                [bindValue]="'orderIndex'"
                [isSearchable]="'true'"
        ></ccl-simple-select> -->
        <!-- <div class="c-form-group__hint">&nbsp;</div>
        </div> 
    </div>
</div> -->
